import fromNullable from "../lib/core/functional/fromNullable";

const queryDOM = (selector) => (container) => fromNullable(container.querySelector(selector));

export default queryDOM;
